// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_VersaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /implantacao/checklist_atualizar — passa a jornada para a versão vigente do checklist
 * (Full). O que já foi marcado fica, pela chave do item. Chamado NS 2026-0079.
 */
import { registerContract } from './validate'

export interface Implantacao_VersaoInput {
franquia_id?: number
}

registerContract('Implantacao_VersaoInput', {
  franquia_id: { type: 'number',  required: false },
})
